<template>
  <div class="bp-disclaimer-container">
    <div class="bp-disclaimer-header">Exclusions & Disclaimers</div>
    <div class="bp-disclaimer-body-container">
      <div class="bp-disclaimer-body-header">Smart Maintenance&reg; Disclaimer</div>
      <div class="bp-disclaimer-body">
        Pricing:
        <ul class="margin-bottom-4">
          <li>{{ charge("second") }} for second unit</li>
          <li>{{ charge("addon") }} for additional unit</li>
        </ul>
        <span v-if="plan.comfortCreditEnabled || !plan.priceInitial">
          {{ loyaltyName }}:
          <ul>
            <li>Accrue at {{ comfortCredit("second") }} for second unit</li>
            <li>Accrue at {{ comfortCredit("addon") }} for additional units</li>
          </ul>
          <div class="padding-elements">
            {{ loyaltyName }} may be applied to any major HVAC expense over
            {{ minRepairCost(plan.minRepairCost) }} dollars.
          </div>
        </span>
      </div>
      <div
        v-if="
          (plan.comfortCreditEnabled && plan.redemptionRestriction) || !plan.priceInitial
        "
        class="bp-disclaimer-body"
      >
        *{{ loyaltyName }} Restrictions: {{ plan.redemptionRestriction }}
      </div>
      <div class="bp-disclaimer-body-title">Partner's Exclusions & Disclaimer</div>
      <div class="bp-disclaimer-body-text">
        {{ planDisclaimer }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExclusionCard",
  props: {
    plan: Object,
    partnerSettings: Object,
  },
  computed: {
    loyaltyName() {
      return this.partnerSettings.LOYALTY_PROGRAM_NAME || "Comfort Credits";
    },
    planDisclaimer() {
      if (this.plan?.disclaimer !== undefined) {
        return this.plan.disclaimer || "--";
      }
      return this.partnerSettings?.PLAN_DISCLAIMER || "--";
    },
  },
  methods: {
    charge(unit) {
      const { priceInitial, priceSecond, priceAddon, chargeFrequency } = this.plan;
      let frequency = chargeFrequency;
      if (frequency === "Yearly") {
        frequency = "year";
      }
      if (frequency === "Monthly") {
        frequency = "month";
      }
      if (frequency === "One time") {
        frequency = "once";
      }
      if (unit === "second" && priceSecond) {
        return `$${priceSecond}/${frequency}`;
      }
      if (unit === "addon" && priceAddon) {
        return `$${priceAddon}/${frequency}`;
      }
      if (unit === "initial" && priceInitial) {
        return `$${priceInitial}/${frequency}`;
      }
      return "{{$-/month}}";
    },
    comfortCredit(unit) {
      const {
        comfortCreditInitial,
        comfortCreditSecond,
        comfortCreditAddon,
        creditAccrualFrequency,
      } = this.plan;
      let frequency = creditAccrualFrequency;
      if (frequency === "Yearly") {
        frequency = "year";
      }
      if (frequency === "Monthly") {
        frequency = "month";
      }
      if (unit === "second" && comfortCreditSecond) {
        return `$${comfortCreditSecond}/${frequency}`;
      }
      if (unit === "addon" && comfortCreditAddon) {
        return `$${comfortCreditAddon}/${frequency}`;
      }
      if (unit === "initial" && comfortCreditInitial) {
        return `$${comfortCreditInitial}/${frequency}`;
      }
      return "{{$-/month}}";
    },
    minRepairCost(cost) {
      if (cost) {
        return `$${cost}`;
      }
      return "{{minInvoicePrice}}";
    },
  },
};
</script>
